import { render, staticRenderFns } from "./PerformanceReview.vue?vue&type=template&id=ea135c0c"
import script from "./PerformanceReview.vue?vue&type=script&lang=js"
export * from "./PerformanceReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports